import type { AnchorHTMLAttributes } from "react";

export function GradientLink({ className = "", children, ...rest }: AnchorHTMLAttributes<HTMLAnchorElement>) {
  return (
    <a
      className={`inline-flex items-center justify-center gap-2 rounded-xl px-5 py-3 text-sm font-medium text-white no-underline shadow-[var(--glow-accent)] transition-[transform,background-color] duration-150 bg-[var(--cta)] hover:bg-[var(--cta-hover)] active:scale-[0.98] ${className}`}
      {...rest}
    >
      {children}
    </a>
  );
}
